import { Component, OnInit } from '@angular/core';
import { Sections } from '../../models/sections';
import { FormsSectionsService } from '../../services/forms.sections.service';
import { Router } from '@angular/router';
import { NbDialogRef, NbToastrService } from '@nebular/theme';
import { CreateFormSectionComponent } from '../create/create.component';

@Component({
  selector: 'app-update-section',
  templateUrl: './update.component.html',
  styleUrls: ['./update.component.scss'],
})
export class UpdateSectionComponent implements OnInit {
  source: Sections = {} as Sections;
  sourceId: number;
  constructor(
    private service: FormsSectionsService,
    private router: Router,
    private diag: NbDialogRef<UpdateSectionComponent>,
    private toast: NbToastrService,
  ) {}
  ngOnInit() {
    this.service.getById(this.sourceId).subscribe((res) => {
      this.source = res;
    });
  }

  save() {
    this.service.put(this.sourceId, this.source).subscribe((res) => {
      this.toast.success('Update section successfully', 'success', { duration: 4000 });
      this.diag.close('true');
    });
  }
}
